import ExamMasterList from "../components/ExamMasterList";

export default function MasterLab() {
    return (
        <ExamMasterList
            kind="lab"
            title="Master Laboratorium"
            subtitle="Kelola daftar pemeriksaan laboratorium beserta unit cost dan harga jual."
            testidPrefix="lab"
        />
    );
}
